var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: `${_vm.bg} ${_vm.text} ${_vm.border} hover:${_vm.bgHover} relative inline-flex rounded-full border border-opacity-25 ml-1 p-2 ${_vm.enableClick ? 'cursor-pointer' : ''} transition-all ease-in-out duration-300 `
  }, [_vm.enableClick ? _c('div', {
    staticClass: "absolute w-full h-full top-0 left-0 z-10",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('buttonClick');
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('icon', {
    staticClass: "w-2 h-2 xl:h-4 xl:w-4 transition ease-in-out duration-150",
    class: 'transform scale-' + _vm.iconSize,
    attrs: {
      "name": _vm.icon,
      "label": _vm.label
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }